import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';
import { BasicAccesOrder } from './basic-acces-order.entity';

export abstract class CreationAccesOrder extends BasicAccesOrder {
	parcId!: number;
	ouvrageIds!: number[];
	ouvragesConcernesIds!: number[];

	numero!: string;
	typeAcces!: string;
	dateDebut!: LocalDateTime;
	accesCegex!: boolean;

	constructor() {
		super();
	}
}